
import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FAQKeyword from './FAQKeyword';
import Testimonialskeyword from './TestimonialKeyword';

function Mumbaitoshirdicab() {



    const cardData =
    {
        keyword: 'Mumbai to Shirdi Cab',
        heading: 'Skyline Cabs: Mumbai to Shirdi Cab',
        headingDescription: 'Skyline Cabs offers comfortable and reliable Mumbai to Shirdi Cab services for a spiritual and peaceful journey. Whether you are planning a pilgrimage to the famous Sai Baba Temple or visiting the sacred sites around Shirdi, our well-maintained vehicles and professional drivers ensure a safe and pleasant ride. Enjoy door-to-door pickups from anywhere in Mumbai, transparent pricing, flexible travel schedules, and 24/7 customer support. Book your Mumbai to Shirdi cab with Skyline Cabs today and travel with ease to one of India’s most revered spiritual destinations!',

        top: 'Top Places to Visit in Shirdi with Skyline Cabs',

"topPlaces": [
    {
        "title": "Shri Sai Baba Samadhi Mandir",
        "description": "The main attraction in Shirdi, the Samadhi Mandir houses the final resting place of Shri Sai Baba. Thousands of devotees visit daily to pay their respects, experience spiritual peace, and witness the aarti rituals."
    },
    {
        "title": "Dwarkamai",
        "description": "Dwarkamai is the mosque where Sai Baba spent a significant part of his life. It still retains his sacred presence and includes a stone on which Baba used to sit and the sacred fire (dhuni) that he lit."
    },
    {
        "title": "Chavadi",
        "description": "Chavadi is a small building where Sai Baba used to sleep on alternate nights. The site holds great historical and spiritual significance, and it also houses Baba’s wooden bed and a palanquin used in processions."
    },
    {
        "title": "Gurusthan",
        "description": "Gurusthan, meaning 'place of the guru', is where Sai Baba was first spotted as a 16-year-old boy meditating under a neem tree. Devotees light incense sticks here as a mark of reverence."
    },
    {
        "title": "Sai Heritage Village",
        "description": "This is a theme park and museum that depicts life during Sai Baba's time through statues and models. It provides insight into Shirdi's history and Sai Baba’s teachings in a fun and educational format."
    },
    {
        "title": "Khandoba Mandir",
        "description": "Located near the main temple complex, Khandoba Mandir is where Sai Baba was first welcomed into Shirdi by the priest Mhalsapati. It’s an important spot that marks Baba’s entry into the town."
    },
    {
        "title": "Wet N Joy Water Park",
        "description": "For those looking for leisure and fun, this water park located near the temple complex offers slides, wave pools, and family attractions, making it a great spot for a day out with kids."
    },
    {
        "title": "Lendi Baug",
        "description": "A garden developed and frequented by Sai Baba, Lendi Baug is a peaceful place ideal for reflection. It features a lamp lit by Baba, which is still kept burning inside a small shrine."
    },
    {
        "title": "Shani Shingnapur",
        "description": "Located about 70 km from Shirdi, this famous village is known for its temple dedicated to Lord Shani and its unique tradition of houses without doors. It's a popular pilgrimage destination for those visiting Shirdi."
    },
    {
        "title": "Sai Baba Wax Museum",
        "description": "This museum features lifelike wax statues of Sai Baba and scenes from his life. It offers a visual journey through his spiritual legacy and teachings, especially appealing to children and families."
    }
],

"services": [
    {
      "name": "Mumbai to Shirdi Cab",
      "description": "Skyline Cabs provides comfortable and reliable cab services from Mumbai to Shirdi. Enjoy a peaceful ride on your spiritual journey to Shirdi."
    },
    {
      "name": "Mumbai to Shirdi Taxi",
      "description": "Choose Skyline Cabs for a smooth and timely taxi service from Mumbai to Shirdi. We ensure a stress-free ride with professional drivers."
    },
    {
      "name": "Shirdi Darshan Cab Service",
      "description": "Book a Shirdi Darshan cab with Skyline Cabs. Our service is ideal for pilgrims looking for a convenient and comfortable travel option."
    },
    {
      "name": "Mumbai to Shirdi One Way Cab",
      "description": "Skyline Cabs offers affordable one-way cab services from Mumbai to Shirdi. Perfect for travelers who need a single-trip option."
    },
    {
      "name": "Shirdi Taxi from Mumbai",
      "description": "Get a taxi from Mumbai to Shirdi with Skyline Cabs for a safe and relaxing journey. We make your travel experience smooth and pleasant."
    },
    {
      "name": "Shirdi Cab Booking",
      "description": "Book your cab to Shirdi easily with Skyline Cabs. Enjoy convenient online booking and dependable service for your trip."
    },
    {
      "name": "Taxi for Shirdi",
      "description": "Looking for a taxi to Shirdi? Skyline Cabs offers clean vehicles and experienced drivers to make your journey worry-free."
    }
  ],
  "tableData": [
    ["Mumbai to Shirdi Cab", "Mumbai to Shirdi Taxi"],
    ["Shirdi Darshan Cab Service", "Mumbai to Shirdi One Way Cab"],
    ["Shirdi Taxi from Mumbai", "Shirdi Cab Booking"],
    ["Taxi for Shirdi"]
  ],



  whychoose: [
    {
      "WhyChooseheading": "Reliable Mumbai to Shirdi Cab Service",
      "WhyChoosedescription": "Travel stress-free from Mumbai to Shirdi with our dependable cab service. Perfect for pilgrimages, family visits, or peaceful getaways, we guarantee a smooth ride."
    },
    {
      "WhyChooseheading": "Comfortable and Long-Distance Ready Cabs",
      "WhyChoosedescription": "Our cabs are built for long journeys, offering comfortable seating, great suspension, and a pleasant ride for the sacred trip to Shirdi."
    },
    {
      "WhyChooseheading": "Affordable and Transparent Pricing",
      "WhyChoosedescription": "We offer budget-friendly and honest pricing with no hidden costs—just clear, upfront rates for your Mumbai to Shirdi cab journey."
    },
    {
      "WhyChooseheading": "Experienced and Respectful Drivers",
      "WhyChoosedescription": "Our courteous drivers are experienced in long-distance travel and familiar with the Shirdi route, ensuring a safe and respectful travel experience."
    },
    {
      "WhyChooseheading": "Clean and Sanitized Vehicles",
      "WhyChoosedescription": "Travel with peace of mind in cabs that are well-maintained, thoroughly sanitized, and hygienic—ideal for your spiritual trip to Shirdi."
    },
    {
      "WhyChooseheading": "Flexible Travel Options",
      "WhyChoosedescription": "Choose from one-way, round-trip, or extended stays. Our flexible packages cater to your schedule and travel preferences."
    },
    {
      "WhyChooseheading": "24/7 Booking Support",
      "WhyChoosedescription": "Book your cab anytime online or via phone. Our 24/7 customer support ensures a quick, easy, and smooth booking process."
    },
    {
      "WhyChooseheading": "Ideal for Pilgrimages, Family Trips, or Solo Travel",
      "WhyChoosedescription": "Whether visiting the Sai Baba temple with family or taking a solo spiritual retreat, our cabs offer comfort and reliability for your Mumbai to Shirdi trip."
    }
  ]
  
  
  









    }

    const faqData = [
        {
            id: 1,
            question: 'How can I book a cab from Mumbai to Shirdi with Skyline Cabs?',
            answer:
                'Booking a cab from Mumbai to Shirdi is easy and convenient. You can book through our website, mobile app, or by calling our customer support. Just enter your pickup location, travel date, and choose your preferred vehicle for the journey.',
        },
        {
            id: 2,
            question: 'What is the distance and travel time from Mumbai to Shirdi?',
            answer:
                'The distance from Mumbai to Shirdi is approximately 240 km. The travel time usually ranges from 5 to 6 hours, depending on traffic and road conditions. Our drivers ensure a safe and timely journey by taking the best routes.',
        },
        {
            id: 3,
            question: 'What types of vehicles are available for the Mumbai to Shirdi trip?',
            answer:
                'We offer a range of vehicles for the Mumbai to Shirdi journey including Swift Dzire, Ertiga, Innova Crysta, Kia Carens, and SUVs. For larger groups, Tempo Travellers and luxury coaches are also available.',
        },
        {
            id: 4,
            question: 'Are your cab fares for Mumbai to Shirdi fixed?',
            answer:
                'Yes, we provide fixed and transparent pricing for your Mumbai to Shirdi journey. The fare includes vehicle rental, driver charges, fuel, tolls, taxes, and applicable service fees. You will see the final fare before confirming the booking.',
        },
        {
            id: 5,
            question: 'Can I book a one-way cab from Mumbai to Shirdi?',
            answer:
                'Yes, Skyline Cabs offers both one-way and round-trip cab options from Mumbai to Shirdi, depending on your travel plans.',
        },
        {
            id: 6,
            question: 'What is the best time to travel from Mumbai to Shirdi?',
            answer:
                'Shirdi can be visited year-round, but the best time to travel is from October to March when the weather is pleasant. Skyline Cabs operates in all seasons with experienced drivers for your comfort.',
        },
        {
            id: 7,
            question: 'Are stopovers allowed during the Mumbai to Shirdi journey?',
            answer:
                'Yes, short stopovers for meals, rest, or sightseeing are allowed during the journey. Please inform the driver if you plan to make any specific stops along the way.',
        },
        {
            id: 8,
            question: 'What payment options are available for the Mumbai to Shirdi cab?',
            answer:
                'We accept UPI, credit/debit cards, net banking, and cash payments after the trip. Online payments are securely processed through trusted gateways.',
        },
        {
            id: 9,
            question: 'Can I cancel or modify my Mumbai to Shirdi cab booking?',
            answer:
                'Yes, bookings can be cancelled or modified via our website, mobile app, or customer support. We offer flexible cancellation policies for your convenience.',
        },
        {
            id: 10,
            question: 'Why choose Skyline Cabs for the Mumbai to Shirdi trip?',
            answer:
                'Skyline Cabs ensures a safe, comfortable, and reliable journey to Shirdi. With experienced drivers, clean vehicles, and transparent pricing, we aim to provide a smooth and spiritual travel experience.',
        },
    ];
    
    const someReviews = [
        {
            name: "Mr. Harish Mehta",
            rating: 5,
            review: "Our Shirdi trip with Skyline Cabs was peaceful and comfortable. The driver was courteous, and the vehicle was in great condition. We reached on time for darshan without any hassles. Highly recommend their service!"
        },
        {
            name: "Mrs. Sunita Iyer",
            rating: 4,
            review: "The cab ride from Mumbai to Shirdi was smooth and well-managed. The driver was polite and knew the route well. Slight delay due to traffic, but otherwise everything was perfect. Would book again!"
        },
    ];
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    



    const contactData = {
        heading: `${cardData.keyword} Contact Number`,
        contactNumbers: [
            "+91 7620911746",


        ],
        email: "booking@skylinecabs.com"
    };


    const Images = [
        {
            place: "/images/keyword/1.jpg",
            text: "Pune to Mumbai Cab",
        },
        {
            place: "/images/keyword/2.jpg",
            text: "Pune to Mumbai Airport Cab",
        },
        {
            place: "/images/keyword/3.jpg",
            text: "Pune to Mumbai International Airport Cab",
        },
        {
            place: "/images/keyword/4.jpg",
            text: "Pune to Mumbai One Way Cab",
        },
        {
            place: "/images/keyword/5.jpg",
            text: "Pune Mumbai Car Hire",
        },
        {
            place: "/images/keyword/6.jpg",
            text: "  Pune to Mumbai Taxi Fare ",
        },
        {
            place: "/images/keyword/7.jpg",
            text: "Pune to Mumbai Online Cab Booking",
        },

        {
            place: "/images/keyword/8.jpg",
            text: " Pimpri Chinchwad to Mumbai Cab",
        },

        {
            place: "/images/keyword/9.jpg",
            text: "Baner to Mumbai Cabs",
        },
        {
            place: "/images/keyword/10.jpg",
            text: "Hinjewadi to Mumbai Cab",
        },

        {
            place: "/images/keyword/11.jpg",
            text: "Pimple Saudagar to Mumbai Cab Service",
        },
        {
            place: "/images/keyword/12.jpg",
            text: "Wakad to Mumbai Cab",
        },

        {
            place: "/images/keyword/13.jpg",
            text: "Hadapsar to Mumbai Cab",
        },

        {
            place: "/images/keyword/14.jpg",
            text: "Kalyani Nagar to Mumbai Taxi",
        },
        {
            place: "/images/keyword/15.jpg",
            text: "Koregaon Park to Mumbai Cab",
        },
        {
            place: "/images/keyword/16.jpg",
            text: " Kothrud to Mumbai Cab",
        },
        {
            place: "/images/keyword/17.jpg",
            text: "Kharadi to Mumbai Cab",
        },
        {
            place: "/images/keyword/18.jpg",
            text: "Shivajinagar to Mumbai Cab",
        },
        {
            place: "/images/keyword/19.jpg",
            text: "Pune to Mumbai Ertiga Cab",
        },
        {
            place: "/images/keyword/20.jpg",
            text: " Pune to Mumbai Innova Crysta Cab",
        },
        {
            place: "/images/keyword/21.jpg",
            text: " Pune to Mumbai Sedan Cab",
        },
        {
            place: "/images/keyword/22.jpg",
            text: "Kondhwa to Mumbai Cab",
        },
        {
            place: "/images/keyword/23.jpg",
            text: "Viman Nagar to Mumbai Cabs",
        },
        {
            place: "/images/keyword/24.jpg",
            text: "Katraj to Mumbai Cab Service",
        },
        {
            place: "/images/keyword/25.jpg",
            text: " Pune Station to Mumbai Cabs Service",
        },
        {
            place: "/images/keyword/26.jpg",
            text: "Boat Club Road to Mumbai Cab ",
        },
        {
            place: "/images/keyword/27.jpg",
            text: " Vishrantwadi to Mumbai Cab",
        },
    ];


    const images = [
        { src: "/images/ourfleet/1.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/5.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/2.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/3.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/4.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/7.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/8.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/9.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/6.jpg", alt: "Image 1" },

    ];



  const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Mumbai to Shirdi Cab",
  "image": "https://skylinecabs.com/assets/images/mumbai-to-shirdi-cab.jpg",
  "description": "Book Mumbai to Shirdi Cab with Skyline Cabs for a smooth and spiritual journey to Sai Baba Temple. Enjoy clean AC sedans, SUVs, or tempo travellers with experienced drivers — 24/7 availability and affordable fares for families and pilgrims.",
  "brand": {
    "@type": "Brand",
    "name": "Skyline Cabs"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.9",
    "ratingCount": "9021"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "3200",
    "availability": "https://schema.org/InStock",
    "url": "https://skylinecabs.com/mumbai-to-shirdi-cab"
  }
};


      
      
      

    return (
        <div>

<Helmet>
  <title>Mumbai to Shirdi Cab | Sai Baba Temple Darshan Taxi | Skyline Cabs</title>
  <meta 
    name="description" 
    content="Book Mumbai to Shirdi Cab with Skyline Cabs for a smooth and spiritual journey to Sai Baba Temple. Enjoy clean AC sedans, SUVs, or tempo travellers with experienced drivers — 24/7 availability and affordable fares for families and pilgrims." 
  />
  <meta 
    name="keywords" 
    content="Mumbai to Shirdi Cab, Sai Baba Darshan Cab Mumbai, AC Cab Mumbai to Shirdi, SUV Taxi to Shirdi, Mumbai Shirdi Tempo Traveller, Online Cab Booking Shirdi, Skyline Cabs Mumbai to Shirdi, One Way Cab Mumbai to Shirdi" 
  />
  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>

            <section
                className="bg-cover position-relative"
                style={{
                    background: 'url(/img/bg-title.jpg) no-repeat',
                }}
                data-overlay="5"
            >
                <div className="container">
                    <div className="row align-items-center justify-content-center">
                        <div className="col-xl-7 col-lg-9 col-md-12">
                            <div className="fpc-capstion text-center my-4">
                                <div className="fpc-captions">
                                    <h1 className="xl-heading text-light">{cardData.keyword}</h1>

                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>


            <section>
                <div className="container-fluid" >
                    <div className="row container-fluid">
                        <div className="col-12 col-md-7 ">
                            <img src='/images/keyword/88.jpg' alt='img' className='img-fluid'/>
                            <h3 className="py-1"
                                style={{
                                    color: '#F26722', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="">
                                <p className='fw-bold py-3 darkcolor'>{cardData.top}</p>
                                {cardData.topPlaces.map((place, index) => (
                                    <div key={index} className="">
                                        <div
                                            style={{
                                                cursor: 'pointer',
                                                padding: '10px',
                                                marginBottom: '7px',
                                                borderRadius: '8px',
                                                transition: 'transform 0.2s'
                                            }}

                                        >
                                            <h4 className="mb-1 darkcolor">{place.title}</h4>
                                            <p className="mb-0">{place.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>
                            <div
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    marginBottom: '7px',
                                    borderRadius: '8px', // Optional: rounded corners
                                    transition: 'transform 0.2s' // Optional: smooth scaling effect
                                }}
                            >
                                {cardData.services.map((service, index) => (
                                    <div key={index} className=" my-4">
                                        <h4 className="py-1 darkcolor">{service.name}</h4>
                                        <p>{service.description}</p>
                                    </div>
                                ))}
                            </div>

                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section"
                                className='px-2'>
                                {cardData.whychoose.map((item, index) => (
                                    <div key={index}>
                                        <h4 className="py-1 whycolor">{item.WhyChooseheading}</h4>
                                        <p>{item.WhyChoosedescription}</p>
                                    </div>
                                ))}
                            </div>


                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Skyline Cabs</h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">


                                                <FAQKeyword faqData={faqData} />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>


                            <Testimonialskeyword reviews={someReviews} />

                            <div className='py-4'>

                                <div className="contact-box Borderr">
                                    <h3>{contactData.heading}</h3>
                                    <p className='text-black'>For booking inquiries or any assistance, please feel free to contact us:</p>
                                    <div className="contact-details">
                                        <p><strong className='darkcolor'>Mobile No:</strong></p>
                                        <ul>
                                            {contactData.contactNumbers.map((number, index) => (
                                                <li key={index}>
                                                    <a href={`tel:${number}`} className="contact-link fw-bold fs-5">
                                                        {number}
                                                    </a>
                                                </li>
                                            ))}
                                        </ul>
                                        <p><strong className='darkcolor'>Email Id: </strong>
                                            <a href={`mailto:${contactData.email}`} className="contact-link">
                                                {contactData.email}
                                            </a>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className='col-12 col-md-4' >
                            {Images.map((e) => {
                                return (
                                    <div className="box1">
                                        <a
                                            href="./"
                                            className="d-flex justify-content-around align-items-center"
                                        >
                                            <div className="b1">
                                                <img src={e.place} alt="img" />
                                            </div>
                                            <div className="b2">
                                                {" "}
                                                <a href="./" className='px-3'>{e.text}</a>
                                            </div>
                                        </a>
                                    </div>
                                );
                            })}


                            {/* <div className="gallery-container">
                                <h2 className="gallery-title">Our Fleets</h2>
                                <div className="gallery-row d-flex flex-wrap">
                                    {images.map((image, index) => (
                                        <div className="gallery-item col-md-4" key={index}>
                                            <img
                                                src={image.src}
                                                alt={image.alt}
                                                className="gallery-image"

                                            />
                                        </div>
                                    ))}

                                </div>
                            </div> */}

                            <div className=" rounded p-4 shadow-sm Uni_border "
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    border: '3px dotted #F26722',
                                    marginBottom: '7px',
                                    fontWeight: 'bold',
                                }}

                            >
                                <h4 className="pb-3 pt-3 lead fw-bold text-dark">Contact Information</h4>

                                <div className="row">

                                    <div className="col-12 mb-3">
                                        <div className="Small_border  rounded text-center py-2 " style={{ backgroundColor: '#F26722' }}>
                                            <h4 className=" lead fw-semibold whitt text-dark">Phone Numbers</h4>
                                            <div className=''>
                                                <a href="tel:+91 7620911746" className="d-block  text-white">+91 7620911746</a>


                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border rounded text-center">
                                            <div className='rounded py-2' style={{ backgroundColor: '#F26722' }}>
                                                <h4 className=" fw-semibold lead whitt text-dark">Email</h4>
                                                <a href="mailto:booking@skylinecabs.com" className=" text-white d-block">
                                                    booking@skylinecabs.com
                                                </a>
                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border  rounded text-center">
                                            <div className='rounded py-2' style={{ backgroundColor: '#F26722' }}>
                                                <h4 className=" fw-semibold lead whitt text-dark">Address</h4>
                                                <p className="whit text-white ">
                                                    <i> Skyline Cab<br />
                                                        Satya Nagar, 90 feet rd Saki Naka, Mumbai, Andheri Maharashtra 400072

                                                    </i>
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>



                        </div>
                    </div>
                </div>
            </section>



        </div>
    );
}

export default Mumbaitoshirdicab;